const ADMIN_ROLES = ["Owner", "Admin"];

export function isReadOnly() {
  try {
    return !!JSON.parse(localStorage.getItem("userData")).readOnly;
  } catch (e) {
    return false;
  }
}

export function isManagementRole(role) {
  return role === "Owner" || role === "Admin" || role === "MultiUser";
}

function usersLevel(actor) {
  const access = actor && actor.access;
  return (access && access.users && access.users.level) || null;
}

function isAdministrator(user) {
  return (
    ADMIN_ROLES.includes(user && user.role) ||
    (user && user.accessRole) === "hseAdministrator"
  );
}

export function canAssignTags(actor) {
  if (!actor) return false;
  if (isManagementRole(actor.role)) return true;
  return ["A", "V"].includes(usersLevel(actor));
}

export function canDeleteUser(actor, target) {
  if (!canManageUser(actor, target)) return false;
  if (actor && actor.role === "User") {
    return ["A", "V"].includes(usersLevel(actor));
  }
  return true;
}

export function canManageUser(actor, target) {
  if (!actor || !target) return false;

  const actorId = String(actor._id || actor.id || "");
  const targetId = String(target._id || target.id || "");
  const self = !!actorId && actorId === targetId;

  const protectedRoles = ["MultiUser", "Owner"];
  if (protectedRoles.includes(actor.role) && protectedRoles.includes(target.role)) {
    return false;
  }

  if (target.role === "MultiUser") {
    return self && actor.role === "MultiUser";
  }

  if (self) {
    return ADMIN_ROLES.includes(actor.role) || actor.role === "MultiUser";
  }

  if (actor.role === "User") {
    const level = usersLevel(actor);
    if (level === "A") return true;
    if (level === "V") return !isAdministrator(target);
    return false;
  }

  return ADMIN_ROLES.includes(actor.role) || actor.role === "MultiUser";
}
